import { useEffect, useState, useCallback } from "react";
import { IDetalle, IRequestActualizarEquipo, IRequestDetalleEquipo } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { HistoricoEstadoEquipoService } from "../../../../services/auxiliar/HistoricoEstadoEquipo";
import { IDetalleEquipo } from "./DetalleEquipo";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";

export type keyType = "operadorKey" | "estadoKey" | "ubicacionKey" | "razonKey";
export type textType = "operadorText" | "estadoText" | "ubicacionText" | "razonText";

export interface IFilter2 {
  operadorKey: string;
  operadorText: string;
  ubicacionKey: string;
  ubicacionText: string;
  razonKey: string;
  razonText: string;
  estadoKey: string;
  estadoText: string;
}

const initialFilter2: IFilter2 = {
  operadorKey: "",
  operadorText: "",
  estadoKey: "",
  estadoText: "",
  ubicacionKey: "",
  ubicacionText: "",
  razonKey: "",
  razonText: "",
};

export interface IT {
  key: keyType;
  keyValue: string;
  text: textType;
  textValue: string;
}

export const UseDetalleEquipo = (props: IDetalleEquipo) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<IDetalle | null>(null);
  const [filter2, setFilter2] = useState<IFilter2>({ ...initialFilter2 });
  const [control, setControl] = useState(true);
  const [filter, setFilter] = useState<IRequestDetalleEquipo>({
    skip: 0,
    take: 50,
    equipoId: props.equipoId ?? "", 
    search: "",
  });

  const inital: IRequestDetalleEquipo = {
    skip: 0,
    take: 50,
    equipoId: props.equipoId ?? "", 
    search: "",
  };

  const resetFilter2 = () => {
    setFilter2({ ...initialFilter2 });
    setFilter({
      skip: 0,
      take: 50,
      search: "",
      equipoId: props.equipoId ?? "", 
    });
    setControl(true);
  };

  const getDetalle = () => {
    HistoricoEstadoEquipoService.ListarTotalByEquipo(filter)
      .then((res) => {
        const pag: IPaginationV2 = {
          currentPage: res.data.page,
          total: res.data.total,
          pageSize: res.data.pages,
          onPageChange: onSkip,
          skip: filter.skip,
          take: filter.take,
          onSizeChange: onChangeTake,
        };
        setPagination(pag);
        setItems(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const VerificarActualizar=(equipoId:string)=>{
    const request:IRequestActualizarEquipo={
      equipoId: equipoId
    }
     HistoricoEstadoEquipoService.ActulizarHistoricoEstado(request).then(res=>{
       
     }).catch((e)=>{})
  }
  useEffect(()=>{
    VerificarActualizar(props.equipoId)
  },[])

  const _onkeyUpSearchTable = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
    setControl(true);
  };

  const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value });
    setControl(true);
  };

  const onSkip = (value: number) => {
    const realSkip = value * filter.take - filter.take;
    setFilter({ ...filter, skip: realSkip });
    setControl(true);
  };

  const handleResetUpdate = () => {
    setFilter(inital);
    setControl(true);
  };

  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {},
    onSizeChange: function (value: number): void {},
  });

  const onChangeComboFilter = ({ key, keyValue, text, textValue }: IT) => {
    setFilter2((prevState) => ({
      ...prevState,
      [key]: keyValue,
      [text]: textValue,
    }));
  };

  const buscar = () => {
    setFilter({
      skip: 0,
      take: 50,
      search: "",
      equipoId: props.equipoId ?? "",
      operadorId: filter2.operadorKey !== "" ? filter2.operadorKey : undefined,
      estadoId: filter2.estadoKey !== "" ? filter2.estadoKey : undefined,
      razonId: filter2.razonKey !== "" ? filter2.razonKey : undefined,
      ubicacionId: filter2.ubicacionKey !== "" ? filter2.ubicacionKey : undefined,
    });
    setControl(true);
  };

  useEffect(() => {
    if (control) {
      getDetalle();
      setControl(false);
    }
  }, [control]);

  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    getDetalle,
    handleResetUpdate,
    onChangeTake,
    _onkeyUpSearchTable,
    buscar,
    onChangeComboFilter,
    resetFilter2,
    filter2,
  };
};
